import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export function CodeStep({ challenge, onBack, onDone }) {
  const { verifyCode } = useAuth();
  const [code, setCode] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(code)) return toast.error("Inserisci il codice di 6 cifre");
    setBusy(true);
    try { await verifyCode(challenge.challenge_id, code, remember); onDone(); }
    catch (err) { toast.error(err.message); if (/accedi di nuovo/i.test(err.message)) onBack(); }
    finally { setBusy(false); }
  };
  const resend = async () => {
    try { await api("/web/2fa/resend", { method: "POST", body: { challenge_id: challenge.challenge_id } }); toast.success("Nuovo codice inviato"); } catch (err) { toast.error(err.message); }
  };
  return (
    <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="twofa-form">
      <ShieldCheck className="w-10 h-10 text-[var(--teal)] mb-4" />
      <h2 className="font-display text-3xl font-bold text-white mb-2">Codice di verifica</h2>
      <p className="text-white/60 text-sm mb-8" data-testid="twofa-hint">Abbiamo inviato un codice di 6 cifre a <b className="text-white">{challenge.email_hint}</b>. Vale 10 minuti.</p>
      <Input inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} placeholder="000000"
        className="h-14 text-center text-2xl tracking-[0.5em] bg-white/5 border-white/15 text-white mb-5" data-testid="twofa-code-input" autoFocus />
      <label className="flex items-center gap-2 text-sm text-white/70 mb-8 cursor-pointer">
        <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} data-testid="twofa-remember" />Ricorda questo dispositivo per 30 giorni
      </label>
      <Button type="submit" disabled={busy} className="w-full h-12 rounded-full bg-[var(--teal)] hover:bg-[#257474] text-white font-semibold" data-testid="twofa-submit">{busy ? "Verifica..." : "Conferma"}</Button>
      <div className="flex justify-between mt-6 text-sm">
        <button type="button" onClick={onBack} className="text-white/50 hover:text-white" data-testid="twofa-back">Indietro</button>
        <button type="button" onClick={resend} className="text-[var(--teal)] hover:underline" data-testid="twofa-resend">Invia un nuovo codice</button>
      </div>
    </form>
  );
}
